/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('SystemSettings', function($scope, $http, $q, _$toast, $timeout, $rootScope, Upload) {
    $scope.errorMessage = function() {
        _$toast.message('Formularz nie jest prawidłowo wypełniony');
    };

    $scope.successMessage = function() {
        _$toast.message('Zmiany zostały zapisane');
    };

    $scope.institution = {};
    $scope.saveInstitution = function() {
        $scope.institution.county = $scope.counties.selected.name;
        $http.post('/administration/settings/institution', $scope.institution)
            .success(function(result) {
                angular.element(document.querySelector('#topTitleBar')).text($scope.institution.name);
                $scope.successMessage();
            });
    };

    $scope.email = {};
    $scope.saveEmail = function() {
        $http.post('/administration/settings/email', $scope.email)
            .success(function(result) {
                $scope.email.password_org = "";
                $scope.email.password = true;
                $scope.successMessage();
            });
    };

    $scope.sms = {};
    $scope.saveSms = function() {
        $http.post('/administration/settings/sms', $scope.sms)
            .success(function(result) {
                $scope.sms.password_org = "";
                $scope.sms.password = true;
                $scope.successMessage();
            });
    };

    $scope.epuap = {};
    $scope.epuapCert = "";
    $scope.saveEpuap = function() {
        $http.post('/administration/settings/epuap', $scope.epuap)
            .success(function(result) {
                if (typeof $scope.epuap.file != "undefined") {
                    Upload.upload({
                        url: '/administration/settings/epuap/upload',
                        file: $scope.epuap.file
                    }).then(function(response) {
                        if(response.data.code)
                          $scope.epuap.cert_file = $scope.epuap.file.name;
                        $rootScope.notification.show(response.data.code ? 'success' : 'error', response.data.msg);
                    }, function(response) {
                        $rootScope.notification.show('error', 'Wystąpił problem z zapisaniem pliku');
                    }, function(evt) {
                        if(typeof evt.data != "undefined")
                          $rootScope.notification.show(evt.data.code ? 'success' : 'error', evt.data.msg);
                    });
                } else {
                    $scope.successMessage();
                }
            });
    };

    $scope.general = {};
    $scope.custom = {};
    $scope.saveGeneral = function() {
        $http.post('/administration/settings/general', {
              'general' : $scope.general,
              'custom' : $scope.custom
            })
            .success(function(result) {
                $scope.successMessage();
            });
    };

    $scope.api = {};
    $scope.notifications = [];
    $scope.saveApi = function() {
        $http.post('/administration/settings/api', $scope.api)
            .success(function(result) {
                $scope.successMessage();
            });
    };

    /*$scope.sekap = {};
    $scope.saveSekap = function(){
       $http.post('/administration/settings/sekap', $scope.sekap)
         .success(function(result) {
             $scope.successMessage();
         });
    };*/

    $scope.upload = {
        cert: function() {
            if ($scope.epuap.file != null && typeof $scope.epuap.id != "undefined") {
                Upload.upload({
                    url: '/administration/settings/epuap/upload',
                    file: $scope.epuap.file
                }).then(function(response) {
                    if(response.data.code)
                      $scope.epuap.cert_file = $scope.epuap.file.name;
                    $rootScope.notification.show(response.data.code ? 'success' : 'error', response.data.msg);
                }, function(response) {
                    $rootScope.notification.show('error', 'Wystąpił problem z zapisaniem pliku');
                }, function(evt) {
                    if(typeof evt.data != "undefined"){
                      $rootScope.notification.show(evt.data.code ? 'success' : 'error', evt.data.msg);
                    }
                });
            }
        },
    };

    $scope.checkForm = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });

            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');

            return false;
        }
    };

    $scope.counties = {
        list: [],
        item: null,
        text: null
    };
    $scope.countySearch = function(query) {
        var deferred = $q.defer();
        $http.post('/teryt/county', {
                name: query,
                state: $scope.institution.voivodeship
            })
            .success(function(list) {
                $scope.counties.list = list;
                deferred.resolve($scope.counties.list.filter($scope.createFilterFor(query)));
            });

        return deferred.promise;
    };
    $scope.createFilterFor = function(query) {
        return function filterFn(item) {
            return (angular.lowercase(item.name).indexOf(angular.lowercase(query)) === 0);
        };
    };


    $scope._init = function() {
        $q.all([
            $http.get('/administration/settings/institution'),
            $http.get('/administration/settings/email'),
            $http.get('/administration/settings/sms'),
            $http.get('/administration/settings/epuap'),
            $http.get('/administration/settings/general'),
            $http.get('/administration/settings/api')
            //$http.get('/administration/settings/sekap')
        ]).then(function(values) {
            if (!_.isNull(values[0].data.institution)) {
                $scope.institution = values[0].data.institution;
                $timeout(function() {
                    $scope.counties.selected = values[0].data.institution.county;
                }, 100);
            }

            if (!_.isNull(values[1].data.email)) {
                $scope.email = values[1].data.email;
                $scope.email.active = $scope.email.active == 1;
            }

            if (!_.isNull(values[2].data.sms)) {
                $scope.sms = values[2].data.sms;
                $scope.sms.active = $scope.sms.active == 1;
            }

            if (!_.isNull(values[3].data.epuap)) {
                $scope.epuap = values[3].data.epuap;
                $scope.epuap.active = $scope.epuap.active == 1;
                $scope.epuap.cert_file_org = "";
            }

            if (!_.isNull(values[4].data.general)) {
                $scope.general = values[4].data.general;
            }

            if (!_.isNull(values[4].data.custom)) {
                $scope.custom = values[4].data.custom;
            }

            if (!_.isNull(values[5].data.api)) {
                $scope.api = values[5].data.api;
                $scope.api.active = $scope.api.active == 1;
            }

            // if (!_.isNull(values[6].data.sekap)) {
            //     $scope.sekap = values[6].data.sekap;
            //     $scope.sekap.active = $scope.sekap.active == 1;
            // }

            $scope.notifications = values[5].data.notifications;
        });
    };

    $scope.importDocs = function() {
        $http.post('/administration/settings/importepuapdocs')
            .success(function(result) {
                if (result.code == 2)
                    _$toast.message(result.msg);
                else
                    $rootScope.notification.show(result.code ? 'success' : 'error', result.msg);
            }).error(function() {
                $rootScope.notification.show('error', 'Import dokumentów nie powiódł się');
            });
    };

    $scope._init();
});
